import { Observable } from 'rxjs';

import ClassifierValue from '../interfaces/classifierValue';
import { ObtainType } from '../interfaces/obtainType';
import Paginate from '../interfaces/paginate';
import { Product } from '../interfaces/product';
import { ProductObtainType } from '../enums/product-obtain-type';
import { HttpClient, ListParams } from './http-client';
import Classifier from '../enums/classifier';
import { ClassifierValuePropertyWithType } from 'src/interfaces/classifierValueProperty';

export class ProductService extends HttpClient {
  index(farmId: string, params: ListParams) {
    return this.get<Paginate<Product>>(`/api/farms/${farmId}/products`, params);
  }

  show(farmId: string, id: string): Observable<Product> {
    return this.get<Product>(`/api/farms/${farmId}/products/${id}`);
  }

  store(farmId: string, product: Product): Observable<Product> {
    return this.post<Product>(`/api/farms/${farmId}/products`, product);
  }

  update(farmId: string, id: string, product: Product): Observable<Product> {
    return this.put<Product>(`/api/farms/${farmId}/products/${id}`, product);
  }

  productObtainTypes(farmId: string): Observable<ObtainType[]> {
    return this.get<ObtainType[]>(
      `/api/farms/${farmId}/products/product-obtain-types`
    );
  }

  usedProductCategories(
    farmId: string,
    params?: {
      product_obtain_type_id: ProductObtainType | ProductObtainType[];
      classifier_key?: Classifier | Classifier[];
      [key: string]: string | any[];
    }
  ): Observable<ClassifierValue[]> {
    return this.get<ClassifierValue[]>(
      `/api/farms/${farmId}/products/used-product-categories`,
      params
    );
  }

  usedProductTypes(
    farmId: string,
    params?: {
      product_obtain_type_id: ProductObtainType | ProductObtainType[];
      classifier_key?: Classifier | Classifier[];
      [key: string]: string | any[];
    }
  ): Observable<ClassifierValue[]> {
    return this.get<ClassifierValue[]>(
      `/api/farms/${farmId}/products/used-product-types`,
      params
    );
  }

  usedProducts(
    farmId: string,
    params?: {
      category_id?: string;
      type_id?: string;
      obtain_type_id: ProductObtainType | ProductObtainType[];
      [key: string]: string | any[];
    }
  ): Observable<{
    products: Paginate<Product>;
    classifiers: Paginate<ClassifierValuePropertyWithType>;
    types: ClassifierValue[];
  }> {
    return this.get<{
      products: Paginate<Product>;
      classifiers: Paginate<ClassifierValuePropertyWithType>;
      types: ClassifierValue[];
    }>(`/api/farms/${farmId}/products/used-products`, params);
  }
}
